import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import LogoMarquee from "@/components/LogoMarquee";
import Features from "@/components/Features";
import NicheFinder from "@/components/NicheFinder";
import AppBuilder from "@/components/AppBuilder";
import Examples from "@/components/Examples";
import Manifesto from "@/components/Manifesto";
import EditorialMarquee from "@/components/EditorialMarquee";
import Testimonials from "@/components/Testimonials";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      // Still support hash navigation without smooth engine
      if (window.location.hash) {
        const el = document.querySelector(window.location.hash);
        el?.scrollIntoView();
      }
      return;
    }
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    // Handle arriving with a hash (e.g. from /b/:slug -> /#chat)
    if (window.location.hash) {
      const target = window.location.hash;
      setTimeout(() => {
        const el = document.querySelector(target);
        if (el) lenis.scrollTo(el, { offset: -80, immediate: false });
      }, 300);
    }

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <LogoMarquee />
        <Features />
        <NicheFinder />
        <AppBuilder />
        <Examples />
        <Manifesto />
        <EditorialMarquee />
        <Testimonials />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}
